import { NextPage } from 'next';

import { Search } from '@/components/Search/Search';
import { NAVIGATION_ITEM_SEARCH } from '@/config/constants';
import { CacheTag } from '@/cutils/page-context/edge-cache-tags';
import { createDefaultGetServerSideProps } from '@/cutils/page-context/server-side-props';

const Page: NextPage = () => {
	return <Search navItem={NAVIGATION_ITEM_SEARCH} />;
};

export const getServerSideProps = createDefaultGetServerSideProps(() => {
	return {
		props: { navigationTitle: NAVIGATION_ITEM_SEARCH.pageTitle, cacheTags: new Set<CacheTag>() },
	};
});

export default Page;
